<template>

    <div class="p-4 bg-red-900 min-h-screen flex justify-center items-center">
        <div class="w-full max-w-md">
            <logo  />
            <form class="mt-6 bg-white rounded-lg shadow-xl overflow-hidden" @submit.prevent="store">
                <div class="px-10 py-12"> 
                    <h1 class="text-center font-bold text-3xl">Registrarse</h1>

                    <h1 class="mt-8 justify-center items-center text-center">
                        <a aria-label="Ayuda" href="https://www.youtube.com/watch?v=gtCnMitQ_74" target="_blank"
                           class="ml-auto btn-register font-bold text-black justify-center items-center">Ayuda</a>
                    </h1>

                    <div class="mx-auto mt-6 w-24 border-b-2" />

                    <text-input required v-model="form.nombre" :error="form.errors.nombre" class="mt-10" label="Nombre" />
                    <text-input required v-model="form.apellido" :error="form.errors.apellido" class="mt-10" label="Apellido" />
                    <text-input required v-model="form.cuil" :error="form.errors.cuil" class="mt-10" label="Cuil" />
                    <p class="m-6 text-gray-400 w-full">Cuil sin guíones (-). Ejemplo: 20111111118</p>
                    <text-input required v-model="form.email" :error="form.errors.email" class="mt-10" label="Email" />
                    <text-input required v-model="form.password" :error="form.errors.password" class="mt-6" type="password" autocomplete="new-password" label="Contraseña" />
                    <text-input required v-model="form.password_confirmation" :error="form.errors.password_confirmation" class="mt-6" type="password"  label="Confirmar Nueva Contraseña" />

                    <vue-recaptcha :sitekey="$page.props.recaptchav2_sitekey" @verify="onCaptchaVerify" class="mt-6"/>
                    <span v-if="recaptcha_error" class="form-error">
                      Por Favor confirma que no sos un robot.
                    </span>

                    <div class=" py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
                        <loading-button :loading="form.processing" class="btn-login" type="submit">Registrarse</loading-button>
                        <Link href="/login" class="ml-auto btn-register font-bold text-black" method="get" aria-label="Cancelar">Cancelar</Link>
                    </div>
                </div>
            </form>
        </div>

    </div>
</template>

<script>
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Logo from '@/Shared/Logo'
import { Link } from '@inertiajs/inertia-vue'
import { VueRecaptcha } from 'vue-recaptcha';


export default {
  metaInfo: { title: 'Registro' },
  components: {
    FileInput,
    LoadingButton,
    SelectInput,
    TextInput,
    Logo,
    Link,
    VueRecaptcha,
  },
  remember: 'form',
  data() {
    return {
        recaptcha_error: false,
        form: this.$inertia.form({
            nombre: null,
            apellido: null,
            email: null,
            password: null,
            password_confirmation: null,
            owner: false,
            photo: null,
            cuil:null
        }),
    }
  },
  mounted(){
        this.$alert('Una vez registrado se le enviara un Email de confirmación','Información', {
            confirmButtonText: 'OK'
        });
  },
  watch: {
        '$page.props.flash.success':function(newError, oldError){
            this.$alert(newError, 'Confirmacion de Registro', {
                confirmButtonText: 'OK'
            });
        },
        '$page.props.errors':function (newError, oldError) {
            if(Object.keys(newError).length > 0){
                let html = '<div><h1><span>El formulario contiene los siguientes errores:</span></h1><br>'
                for (let clave in newError){
                    html += '<ul><li style="color:teal">'+newError[clave]+'</li></ul><br></div>'
                }
                const h = this.$createElement;
                const message = h("div", {domProps:{innerHTML: html}})

                this.$msgbox({
                    title: 'Aviso',
                    message:message,
                    confirmButtonText: 'OK',
                });
            }
        }
    },
  methods: {
    store() {
        if (!this.form['g-recaptcha-response']) {
            // Show error after submit.
            this.recaptcha_error = true;
        }else{
            this.form.post(this.route('register.store'))
        }
    },
    onCaptchaVerify(token) {
        // Provide the token response to the form object.
        this.form['g-recaptcha-response'] = token;
    },
  },
}
</script>
